import React, { useEffect, useState } from "react";
import {
	Form,
	Button,
	Popconfirm,
	message,
	Modal,
	Spin,
	Switch,
	Table,
	Input,
	Select,
	Tag,
} from "antd";
import {
	useAddDistributionMutation,
	useDeleteDistributionMutation,
	useGetDistributionsQuery,
	useUpdateDistributionMutation,
} from "@/redux/services/distribution";

const normalizeSwitchValue = (value) => {
	if (value === true || value === 1 || value === "1") {
		return true;
	}

	if (typeof value === "string") {
		return value.toLowerCase() === "true";
	}

	return false;
};

const Add = () => {
	const [form] = Form.useForm();
	const [isOpen, setIsOpen] = useState(false);

	const [emails, setEmails] = useState([]);

	const handleChange = (value) => {
		setEmails(value);
	};

	const [addDistribution] = useAddDistributionMutation();
	const { refetch } = useGetDistributionsQuery();

	const onFinish = async (values) => {
		await addDistribution({
			...values,
			role_id: 2,
			user_msg_email: values.user_msg_email
				? values.user_msg_email.join(";")
				: undefined,
		})
			.unwrap()
			.then((payload) => {
				refetch();
				form.resetFields();
				setIsOpen(false);
				message.success("Create successful");
			})
			.catch((error) => message.error("Something went wrong..."));
	};

	const handleCancel = () => {
		form.resetFields();
		setIsOpen(false);
	};

	return (
		<div>
			<Button
				style={{ marginBottom: "30px" }}
				onClick={() => setIsOpen(true)}
			>
				新渠道
			</Button>
			<Modal
				title="新渠道"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						取消
					</Button>,
				]}
				width="60%"
			>
				<Form
					form={form}
					onFinish={onFinish}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: 600, marginTop: "30px" }}
					initialValues={{ is_send_message: true }}
				>
					<Form.Item
						name="user_name"
						label="名字"
						rules={[{ required: true, message: "请输入名字" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="user_short_name"
						label="简称"
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="user_phone"
						label="电话"
					>
						<Input />
					</Form.Item>

					<Form.Item
						name="user_email"
						label="主邮箱"
					>
						<Input />
					</Form.Item>
					<Form.Item name="user_msg_email" label="其他邮箱">
						<Select
							mode="tags"
							style={{ width: "100%" }}
							placeholder="请输入电子邮件地址 回车确认"
							onChange={handleChange}
							value={emails}
							tokenSeparators={[",", " "]}
							open={false}
							suffixIcon={null}
						>
							{emails.map((email) => (
								<Select.Option key={email}>
									{email}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item name="user_note" label="备忘">
						<Input />
					</Form.Item>

					<Form.Item
						name="is_send_message"
						label="发送消息"
						valuePropName="checked"
					>
						<Switch />
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};

const Edit = ({ item, isOpen, handleClose }) => {
	const [form] = Form.useForm();
	const [updateDistribution] = useUpdateDistributionMutation();

	const [emails, setEmails] = useState(item?.user_msg_email ?? []);

	const handleChange = (value) => {
		setEmails(value);
	};

	const handleCancel = () => {
		handleClose();
	};

	const onFinish = async (values) => {
		try {
			await updateDistribution({
				...values,
				user_detail_id: item.user_detail_id,
				user_msg_email: values.user_msg_email
					? values.user_msg_email.join(";")
					: undefined,
			});
			message.success("Update successful");
			handleCancel();
		} catch (error) {
			message.error("Something went wrong...");
		}
	};

	useEffect(() => {
		form.setFieldsValue({
			...item,
			user_status: normalizeSwitchValue(item?.user_status),
			is_send_message: normalizeSwitchValue(item?.is_send_message),
		}); // 确保每次 item 更新时，更新表单的字段值
	}, [form, item]);

	return (
		<div>
			<Modal
				title="Edit Distribution"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="60%"
			>
				<Form
					form={form}
					onFinish={onFinish}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: 600, marginTop: "30px" }}
					initialValues={item}
				>
					<Form.Item
						name="user_name"
						label="名字"
						rules={[{ required: true, message: "请输入名字" }]}
					>
						<Input disabled />
					</Form.Item>
					<Form.Item
						name="user_short_name"
						label="简称"
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="user_phone"
						label="电话"
					>
						<Input />
					</Form.Item>

					<Form.Item
						name="user_email"
						label="主邮箱"
					>
						<Input />
					</Form.Item>
					<Form.Item name="user_msg_email" label="其他邮箱">
						<Select
							mode="tags"
							style={{ width: "100%" }}
							placeholder="请输入电子邮件地址 回车确认"
							onChange={handleChange}
							value={emails}
							tokenSeparators={[",", " "]}
							open={false}
							suffixIcon={null}
						>
							{emails.map((email) => (
								<Select.Option key={email}>
									{email}
								</Select.Option>
							))}
						</Select>
					</Form.Item>

					<Form.Item name="user_note" label="备忘">
						<Input />
					</Form.Item>

					<Form.Item
						name="user_status"
						label="状态"
						valuePropName="checked"
						rules={[{ required: true, message: "请选择渠道状态" }]}
					>
						<Switch />
					</Form.Item>

					<Form.Item
						name="is_send_message"
						label="发送消息"
						valuePropName="checked"
					>
						<Switch />
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};

const Distribution = () => {
	const { data, isLoading, isError, refetch } = useGetDistributionsQuery();
	const [deleteDistribution] = useDeleteDistributionMutation();
	const [isOpenEdit, setIsOpenEdit] = useState(false);
	const [editItem, setEditItem] = useState();

	const handleClose = async () => {
		await refetch();
		setIsOpenEdit(false);
		setEditItem(undefined);
	};

	const handleDelete = async (item) => {
		try {
			await deleteDistribution(item.user_detail_id);
			message.success(`Delete successful!`);
			refetch();
		} catch (error) {
			message.error("something went wrong");
			console.log("error", error);
		}
	};

	const columns = [
		{
			title: "名字",
			dataIndex: "user_name",
			key: "user_name",
			editable: true,
		},
		{
			title: "简称",
			dataIndex: "user_short_name",
			key: "user_short_name",
			editable: true,
		},
		{
			title: "电话",
			dataIndex: "user_phone",
			key: "user_phone",
			editable: true,
		},
		{
			title: "主邮箱",
			dataIndex: "user_email",
			key: "user_email",
			editable: true,
		},
		{
			title: "其他邮箱",
			dataIndex: "user_msg_email",
			key: "user_msg_email",
			editable: true,
			render: (item) => {
				var emails = [];
				if(item === "" || item === null){
					emails = [];
				}
				else{
					emails = item?.split(";") ?? [];
				}
				return (
					<div
						style={{
							maxWidth: "300px",
							display: "flex",
							flexWrap: "wrap",
							gap: "5px",
						}}
					>
						{emails.map((email) => (
							<Tag color="blue">{email}</Tag>
						))}
					</div>
				);
			},
		},
		{
			title: "状态",
			dataIndex: "user_status",
			key: "user_status",
			editable: true,
			render: (item) => {
				return (
					<>{normalizeSwitchValue(item) ? "Available" : "Unavailable"}</>
				);
			},
		},
		{
			title: "发送消息",
			dataIndex: "is_send_message",
			key: "is_send_message",
			render: (item) => {
				return <>{normalizeSwitchValue(item) ? "开启" : "关闭"}</>;
			},
		},
		{
			title: "修改",
			dataIndex: "",
			key: "x",
			render: (item) => {
				return (
					<Button
						onClick={() => {
							setIsOpenEdit(true);
							const user_msg_email = item.user_msg_email
								? item.user_msg_email.split(";")
								: [];
							setEditItem({
								...item,
								user_msg_email,
								user_status: normalizeSwitchValue(
									item.user_status
								),
								is_send_message: normalizeSwitchValue(
									item.is_send_message
								),
							});
						}}
					>
						编辑
					</Button>
				);
			},
		},
		{
			title: "删除",
			dataIndex: "",
			key: "x",
			render: (item) => {
				return (
					<Popconfirm
						title="Delete the distribution"
						description="Are you sure to delete this distribution?"
						onConfirm={() => handleDelete(item)}
						okText="Yes"
						cancelText="No"
					>
						<Button danger>删除</Button>
					</Popconfirm>
				);
			},
		},
	];

	if (isLoading) {
		return <Spin />;
	}

	if (isError) {
		return <div>something went wrong</div>;
	}
	return (
		<div>
			<Add />
			<Table dataSource={data} columns={columns} />
			<Edit
				handleClose={handleClose}
				isOpen={isOpenEdit}
				item={editItem}
			/>
		</div>
	);
};

export default Distribution;
